import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import { Button } from 'primereact/button';
import { Routes, Route } from 'react-router-dom';
import Dashbaord from './Dashboard';
import Orders from './Orders';
import Tickets from './Tickets';
import Vendors from './Vendors';
import Delivery from './Delivery';
import Products from './Products';
import Categories from './home/Categories';
import BannersPage from './home/Banners';
import DiscountPage from './home/Discount';
import DeliveryPrice from './home/DeliveryPrice';
import Unauthorized from './Unauthorized';
import ProtectedRoute from '../components/ProtectedRoute';
import Platformfee from './home/Platformfee';



const Main = () => {
    const [visible, setVisible] = useState(true);

    const [sidebar, setSidebar] = useState(window.innerWidth <= 1050);

    const handleResize = () => {
        setSidebar(window.innerWidth <= 1050);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div id='maindiv' style={{ display: 'flex', height: '100vh', width: '100vw' }}>
            {
                !sidebar ? <div
                    style={{
                        width: visible ? '250px' : '0px',
                        overflow: 'hidden',
                        transition: 'width 0.3s ease',
                    }}
                >
                    <Sidebar setVisible={setVisible} />
                </div> : <Sidebar />
            }


            <div style={{ flex: 1, padding: '0.5rem' }}>
                {


                    !sidebar && !visible &&
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', height: '35px', }}>
                        <Button size='small' icon='pi pi-bars' onClick={() => setVisible(!visible)}></Button>
                        <h2 style={{ textAlign: 'center' }}>Knock Deliver</h2>
                    </div>
                }

                <Routes>
                    <Route path="/" element={
                        <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                            <Dashbaord />
                            {/* <Orders /> */}
                        </ProtectedRoute>

                    } />
                    <Route path="/orders" element={

                        <ProtectedRoute allowedRoles={['admin', 'superadmin']}>
                            <Orders />
                        </ProtectedRoute>
                        // <Orders />
                    } />
                    <Route path="/tickets" element={

                        <ProtectedRoute allowedRoles={['superadmin']}>
                            <Tickets/>
                        </ProtectedRoute>
                        // <Orders />
                    } />
                    <Route path="/products" element={

                        // <Products />
                        <ProtectedRoute allowedRoles={['superadmin']}>
                            <Products />
                        </ProtectedRoute>

                    } />
                    <Route path="/vendors" element={
                        <ProtectedRoute allowedRoles={['superadmin']}>
                            <Vendors />
                        </ProtectedRoute>
                    } />
                    <Route path="/riders" element={
                        <ProtectedRoute allowedRoles={['superadmin']}>
                            {/* <Products /> */}
                            <Delivery />
                        </ProtectedRoute>

                    } />
                    <Route path="/categories" element={
                        <ProtectedRoute allowedRoles={['superadmin']}>
                            <Categories />
                            {/* <Products /> */}
                        </ProtectedRoute>


                    } />
                    <Route path="/banners" element={
                        <ProtectedRoute allowedRoles={['superadmin']}>
                            <BannersPage />
                            {/* <Products /> */}
                        </ProtectedRoute>
                    } />
                    <Route path="/codes" element={
                        <ProtectedRoute allowedRoles={['superadmin']}>
                            {/* <Products /> */}
                            <DiscountPage />
                        </ProtectedRoute>
                    } />
                    <Route path="/delivery" element={
                        <ProtectedRoute allowedRoles={['superadmin']}>
                            {/* <Products /> */}
                            <DeliveryPrice />
                        </ProtectedRoute>

                    } />

                    <Route path="/platformfee" element={
                        <ProtectedRoute allowedRoles={['superadmin']}>
                            {/* <Products /> */}
                            <Platformfee />
                        </ProtectedRoute>

                    } />
                    <Route path="/unauthorized" element={<Unauthorized />} />
                </Routes>

            </div>
        </div>
    );
};

export default Main;
